import styled from 'styled-components';

type Props = {
    width?: string;
}

export const ContainerInput = styled.div<Props>`
    width: ${props => props.width};
    /* margin-top: 15px; */
    display: inline-block;
    /* border-right: 10px solid #fff; */
    
    .contentInput{
        display: flex;
        width: 100%;
        position: relative;
        align-items: center;;

        button{
            background: transparent;
            position: absolute;
            border: none;
            right: 8px;

            svg{
                fill: rgba(37, 77, 107, .7);
            }
        }
    }
`;

export const Input = styled.input<Props>`
    width: 100%;
    padding: 0;
    height: 37px;
    font-size: 16px;
    border-top: 0;
    border-left: 0;
    border-bottom: 1px solid #CCC;
    border-right: 0;
    outline: 0;
    transition: all ease .3s;
    padding: 0px 8px;

    &:hover, &:focus {
        /* border-bottom: 2px solid rgba(39, 174, 96, .7); */
        border-bottom: 1px solid rgba(37, 77, 107, .7);
    }
`;

export const LabelInput = styled.label`
    display:block;
    font-size: 12px;
    color: #888;
`;